var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.news.length
    ? _c(
        "div",
        { staticClass: "news-slider" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.news[_vm.currentIndex]
              ? _c("div", { key: _vm.currentIndex, staticClass: "slide" }, [
                  _vm.news[_vm.currentIndex].image
                    ? _c("img", {
                        attrs: {
                          src: _vm.news[_vm.currentIndex].image,
                          alt: "Noticia"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.news[_vm.currentIndex].title))
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.news[_vm.currentIndex].description
                        )
                      }
                    })
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "prev", on: { click: _vm.prevSlide } }, [
            _vm._v("❮")
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "next", on: { click: _vm.nextSlide } }, [
            _vm._v("❯")
          ])
        ],
        1
      )
    : _c("div", { staticClass: "text-center mt-48" }, [
        _c("p", [_vm._v("Cargando noticias...")])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }